// Industry sectors follow INSEE NAF rev. 2 sections (French nomenclature).
// Values come from the BFF organisation contract; "Autre" is the catch-all
// for null/unknown values so the SelectInput never renders empty.
export const KNOWN_INDUSTRY_SECTORS = [
    "Agriculture",
    "Industrie",
    "Construction",
    "Commerce",
    "Transport",
    "Hôtellerie et restauration",
    "Technologie",
    "Finance",
    "Immobilier",
    "Services aux entreprises",
    "Services administratifs",
    "Administration publique",
    "Éducation",
    "Santé",
    "Arts et spectacles",
    "Autres services",
    "Services à la personne",
    "Organismes internationaux",
    "Autre",
];
export const INDUSTRY_SECTOR_FALLBACK = "Autre";
export function normalizeIndustrySector(value) {
    if (!value)
        return INDUSTRY_SECTOR_FALLBACK;
    return KNOWN_INDUSTRY_SECTORS.includes(value)
        ? value
        : INDUSTRY_SECTOR_FALLBACK;
}
